import { createBrowserRouter } from "react-router";
import { Layout } from "./components/layout";
import { Home } from "./pages/home";
import { Services } from "./pages/services";
import { ProjectDetail } from "./pages/project-detail";
import { NotFound } from "./pages/not-found";
import { Admin } from "./pages/admin";
import { OgImageGenerator } from "./pages/og-image-generator";
import { About } from "./pages/about";
import { Contact } from "./pages/contact";
import { Blog } from "./pages/blog";
import { BlogPost } from "./pages/blog-post";
import { Pricing } from "./pages/pricing";
import { Login } from "./pages/login";
import { ErrorBoundary } from "./components/error-boundary";
import { ProtectedRoute } from "./components/protected-route";

export const router = createBrowserRouter([
  {
    path: "/",
    Component: Layout,
    ErrorBoundary: ErrorBoundary,
    children: [
      {
        index: true,
        Component: Home,
        ErrorBoundary: ErrorBoundary,
      },
      {
        path: "services",
        Component: Services,
        ErrorBoundary: ErrorBoundary,
      },
      {
        path: "pricing",
        Component: Pricing,
        ErrorBoundary: ErrorBoundary,
      },
      {
        path: "about",
        Component: About,
        ErrorBoundary: ErrorBoundary,
      },
      {
        path: "contact",
        Component: Contact,
        ErrorBoundary: ErrorBoundary,
      },
      {
        path: "blog",
        Component: Blog,
        ErrorBoundary: ErrorBoundary,
      },
      {
        path: "blog/:slug",
        Component: BlogPost,
        ErrorBoundary: ErrorBoundary,
      },
      {
        path: "projects/:id",
        Component: ProjectDetail,
        ErrorBoundary: ErrorBoundary,
      },
      {
        path: "admin",
        element: (
          <ProtectedRoute>
            <Admin />
          </ProtectedRoute>
        ),
        ErrorBoundary: ErrorBoundary,
      },
      {
        path: "login",
        Component: Login,
        ErrorBoundary: ErrorBoundary,
      },
      {
        path: "og-image-generator",
        Component: OgImageGenerator,
        ErrorBoundary: ErrorBoundary,
      },
      {
        path: "*",
        Component: NotFound,
      },
    ],
  },
]);